<template>

    <span>
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
            <defs>
                <clipPath id="clip-Question_icon">
                    <rect width="20" height="20"/>
                </clipPath>
            </defs>
            <g id="Question_icon" data-name="Question icon" clip-path="url(#clip-Question_icon)">
                <rect width="20" height="20" opacity="0"/>
                <g id="Group_8776" data-name="Group 8776">
                    <g id="info_icon" data-name="info icon" transform="translate(-2 -2)">
                        <g id="Ellipse_915" data-name="Ellipse 915" transform="translate(2 2)" :class="'svg-stroke-block-color ' + svgFillClass" stroke-width="1">
                            <circle cx="10" cy="10" r="10" stroke="none"/>
                            <circle cx="10" cy="10" r="9.5" fill="none"/>
                        </g>
                        <path id="Path_1787" class="svg-secondary-color" data-name="Path 1787" d="M-.9-2.8A3.994,3.994,0,0,1-.731-4.177,3.471,3.471,0,0,1,.13-5.188a15.007,15.007,0,0,0,.964-1.23,1.83,1.83,0,0,0,.287-1.039A1.516,1.516,0,0,0,.995-8.572a1.486,1.486,0,0,0-1.1-.39,1.68,1.68,0,0,0-1.06.338,1.18,1.18,0,0,0-.437.995H-2.892l-.021-.041a2.124,2.124,0,0,1,.776-1.764A3.061,3.061,0,0,1-.109-10.1a2.971,2.971,0,0,1,2.092.687,2.478,2.478,0,0,1,.745,1.917,2.871,2.871,0,0,1-.482,1.613,9,9,0,0,1-1.275,1.5,1.6,1.6,0,0,0-.448.663A3.866,3.866,0,0,0,.444-2.8ZM.492,0H-.916V-1.422H.492Z" transform="translate(12.113 17)" fill="#515b60"/>
                    </g>
                </g>
            </g>
        </svg>
    </span>

</template>

<script>
    export default {
        name: "helpIcon",
        props: {
            svgFillClass: {
                type: String,
                default: 'svg-background-color'
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/helpIcon.vue